export default __webpack_public_path__ + "static/media/rectangleHealthgenom.525577f3.svg";